export default __webpack_public_path__ + "static/media/van-gogh-img.93aeaf53.webp";